/**
 * Screen share snapshot + actions for dock popover (IVSRealtimePanel owns IVS stages).
 */

export type ScreenShareQuality = 'high' | 'medium' | 'low' | 'lower' | 'slideshow';

export interface ScreenShareQualityConfig {
  label: string;
  description: string;
  width: number;
  height: number;
  frameRate: number;
}

export const SCREEN_SHARE_QUALITY_PRESETS: Record<ScreenShareQuality, ScreenShareQualityConfig> = {
  high: {
    label: 'High Quality',
    description: '720p @ 30fps',
    width: 1280,
    height: 720,
    frameRate: 30,
  },
  medium: {
    label: 'Medium',
    description: '720p @ 24fps',
    width: 1280,
    height: 720,
    frameRate: 24,
  },
  low: {
    label: 'Low Bandwidth',
    description: '480p @ 30fps',
    width: 854,
    height: 480,
    frameRate: 30,
  },
  lower: {
    label: 'Lower Bandwidth',
    description: '480p @ 24fps',
    width: 854,
    height: 480,
    frameRate: 24,
  },
  slideshow: {
    label: 'Slide Shows',
    description: '1080p @ 5fps',
    width: 1920,
    height: 1080,
    frameRate: 5,
  },
};

export type ScreenShareControlsApi = {
  hasScreenSharePermission: boolean;
  screenShareEnabled: boolean;
  screenShareLoading: boolean;
  isScreenShareStageConnected: boolean;
  screenShareQuality: ScreenShareQuality;
  setScreenShareQuality: (q: ScreenShareQuality) => void;
  toggleScreenShare: () => Promise<void>;
  isPresentationMode: boolean;
  togglePresentationMode: () => void;
};
